<template>
    <div>
        <v-row>
            <v-col>
                <p class="subtitle-2">
                    <v-icon left>mdi-calendar-clock</v-icon>
                    {{ $t('customer.period.title') }}
                </p>
            </v-col>
        </v-row>

        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            {{ $t('customer.period.table.headers.start') }}
                        </th>
                        <th class="text-left">
                            {{ $t('customer.period.table.headers.end') }}
                        </th>
                        <th class="text-left">
                            {{ $t('customer.period.table.headers.due-date') }}
                        </th>
                        <th class="text-left">
                            {{ $t('customer.period.table.headers.situation') }}
                        </th>
                        <th class="text-left">
                            {{
                                $t('customer.period.table.headers.payment-date')
                            }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in periods" :key="index">
                        <td class="text-left">
                            {{ item.formattedStartAt }}
                        </td>
                        <td class="text-left">
                            {{ item.formattedEndAt }}
                        </td>
                        <td class="text-left">
                            {{ item.formattedDueAt }}
                        </td>
                        <td class="text-left">
                            <v-chip label :color="item.paidColor">
                                {{ item.paidStatus }}
                            </v-chip>
                        </td>
                        <td class="text-left">
                            {{ item.formattedPaidAt }}
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>
import Period from '@/models/Period'

export default {
    props: {
        periods: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        model() {
            return new Period()
        },
    },
}
</script>
